module.exports = __webpack_public_path__ + "static/media/besties-fr.bdf5e31e.png";